import axios from "axios";
import {
  BASE_URL,
  KEY,
  SECRET,
  DEFAULT_KEY,
  DEFAULT_SECRET,
  TCMB_BASE_URL,
  EP_URL,
  EP_KEY,
  EP_SECRET,
  EP_PROD_URL,
  EP_PROD_KEY,
  EP_PROD_SECRET,
} from ".";

export default {
  GetToken() {
    return axios({
      method: "post",
      url: `${BASE_URL}/get-token`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        key: KEY,
        secret: SECRET,
      },
    });
  },

  GetEPToken() {
    return axios({
      method: "post",
      url: `${EP_URL}/get-token`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        key: EP_KEY,
        secret: EP_SECRET,
      },
    });
  },

  GetEPProdToken() {
    return axios({
      method: "post",
      url: `${EP_PROD_URL}/get-token`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        key: EP_PROD_KEY,
        secret: EP_PROD_SECRET,
      },
    });
  },

  GetDefaultToken() {
    return axios({
      method: "post",
      url: `${BASE_URL}/get-token`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        key: DEFAULT_KEY,
        secret: DEFAULT_SECRET,
      },
    });
  },

  GetMallToken(token, uri) {
    return axios({
      method: "post",
      url: `${BASE_URL}/flow/get-mall-token`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        uri: uri,
      },
    });
  },

  CreateCustomer(token, name, lastname, phone) {
    return axios({
      method: "post",
      url: `${BASE_URL}/flow/customer-create`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        name: name,
        lastname: lastname,
        phone: phone,
      },
    });
  },

  GetCustomer(token, field, value) {
    return axios({
      method: "post",
      url: `${BASE_URL}/flow/get-customer`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        [field]: value,
      },
    });
  },

  ThirdPartyCustomerQuery(token, customerID, uri, defaultLanguage) {
    return axios({
      method: "post",
      url: `${BASE_URL}/flow/third-party-customer-query`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        customerID: customerID,
        uri: uri,
        defaultLanguage: defaultLanguage,
      },
    });
  },

  GetTokenInfo(token) {
    return axios({
      method: "post",
      url: `${BASE_URL}/flow/token-info`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  CreateOrder(
    token,
    name,
    lastname,
    phone,
    email,
    locationID,
    additionalNote,
    deliveryTypeInfo,
    extraData = {}
  ) {
    console.log({
      name,
      lastname,
      phone,
      email,
      locationID,
      additionalNote,
      deliveryTypeInfo,
      extraData,
    });
    return axios({
      method: "post",
      url: `${BASE_URL}/flow/order-create`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        name: name,
        lastname: lastname,
        phone: phone,
        email: email,
        locationID: locationID,
        additionalNote: additionalNote,
        deliveryTypeInfo: deliveryTypeInfo,
        ...extraData,
      },
    });
  },

  CustomerOrders(token, customerID, mallID) {
    return axios({
      method: "post",
      url: `${BASE_URL}/flow/order-list`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        customerID: customerID,
        mallID: mallID,
      },
    });
  },

  CustomerOrdersByMallID(token, customerID, mallID) {
    return axios({
      method: "post",
      url: `${BASE_URL}/flow/order-list`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        customerID: customerID,
        mallID: mallID,
      },
    });
  },

  GetOrderWithCode(token, shortCode) {
    return axios({
      method: "post",
      url: `${BASE_URL}/flow/order-list`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        shortCode: shortCode,
        withPosts: true,
      },
    });
  },

  CustomerPosts(token, customerID, mallID) {
    return axios({
      method: "post",
      url: `${BASE_URL}/flow/post-list`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        customerID: customerID,
        mallID: mallID,
      },
    });
  },

  CustomerOrderConfirm(token, customerID, orderID) {
    return axios({
      method: "post",
      url: `${BASE_URL}/flow/order-customer-confirm`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        customerID: customerID,
        orderID: orderID,
      },
    });
  },

  CustomerOrderReject(token, customerID, orderID) {
    return axios({
      method: "post",
      url: `${BASE_URL}/flow/order-customer-reject`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        customerID: customerID,
        orderID: orderID,
      },
    });
  },

  GetLocationList(token, branchID) {
    return axios({
      method: "post",
      url: `${BASE_URL}/flow/location-list`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        branchID: branchID,
      },
    });
  },

  GetMalls(token) {
    return axios({
      method: "post",
      url: `${BASE_URL}/flow/get-mall-list`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  GetMall(token, mallID) {
    return axios({
      method: "post",
      url: `${EP_PROD_URL}/malls/get-mall`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        mallID,
      },
    });
  },

  SendSMS(token, phone, message) {
    return axios({
      method: "post",
      url: `${BASE_URL}/flow/send-sms`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        phone: phone,
        message: message,
      },
    });
  },

  SendEmail(token, email, otp, language) {
    console.log(email, otp, language);
    return axios({
      method: "post",
      url: `${BASE_URL}/flow/send-otp-mail`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        email: email,
        otp: otp,
        language,
      },
    });
  },

  GetAgreement(token, id, language) {
    return axios({
      method: "post",
      url: `${BASE_URL}/flow/agreement${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        language: language,
      },
    });
  },

  SetLanguage(token, customerID, defaultLanguage) {
    return axios({
      method: "post",
      url: `${BASE_URL}/flow/set-customer-default-language`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        customerID: customerID,
        defaultLanguage: defaultLanguage,
      },
    });
  },

  GetExchangeRate() {
    return axios.get(TCMB_BASE_URL);
  },

  GetTokenForPayment() {
    return axios({
      method: "post",
      url: `https://payment.easypointapi.com/get-token`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        key: "2pPaZUxjJI1Za7gUnUb1vFGzQt4McE",
        secret: "oaG6Agf0QGkULPScsQOEkKW7Hxy7Vr",
      },
    });
  },

  Payment(token, conversationID, totalPrice, customer, creditCardInfos, items) {
    console.log({
      token: token || "gelmedi",
      serviceData: {
        conversationID,
        totalPrice: totalPrice,
        paidPrice: totalPrice,
        discount: 0,
        installment: 1,
        currency: "TRY",
        customer,
        creditCardInfos,
        willBeStored: false,
        cardAlias: false,
        items,
      },
    });
    return axios({
      method: "post",
      url: `https://payment.easypointapi.com/flow/payment-with-3d`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        conversationID, // string unique
        totalPrice: totalPrice, // number
        paidPrice: totalPrice, // number
        discount: 0, // number
        installment: 1,
        currency: "TRY",
        customer, // object (name, lastname, phone)
        creditCardInfos, // object (holderName, cardNumber, expYear, expMonth, cvc (strings))
        willBeStored: false,
        cardAlias: false,
        items, // object array (name (Handsfree 1. Paket, Handsfree 2. Paket), price(number))
      },
    });
  },

  CheckPayment(token, conversationID) {
    return axios({
      method: "post",
      url: `https://payment.easypointapi.com/flow/listen`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        conversationID,
      },
    });
  },

  GetErrorPayment(token, conversationID) {
    return axios({
      method: "post",
      url: `https://payment.easypointapi.com/flow/get-payment-error`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        conversationID,
      },
    });
  },

  // iyzico
  // Payment(
  //   sessionId,
  //   customerId,
  //   cardName,
  //   cardNumber,
  //   cardDate,
  //   cardCvv,
  //   price
  // ) {
  //   return axios({
  //     method: "post",
  //     url: `https://api.easypoint.com.tr/payment-api`,
  //     headers: {
  //       Authorization: `Basic RWFzeVBheW1lbnRBcGlVc2VyOk03dXJNJU81M1hNJA==`,
  //       "Content-Type": "application/json",
  //     },
  //     data: {
  //       sessionId: sessionId,
  //       customerId: customerId,
  //       cardName: cardName,
  //       cardNumber: cardNumber,
  //       cardDate: cardDate,
  //       cardCvv: cardCvv,
  //       price: price, // string
  //       callbackUrl: "https://box.easypoint.com.tr/sonuc.html", // payment result sayfası yapılacak. oraya yönlendirilecek
  //     },
  //   });
  // },

  // CheckPayment(paymentId) {
  //   return axios({
  //     method: "get",
  //     url: `https://api.easypoint.com.tr/payment-check/${paymentId}`,
  //     headers: {
  //       Authorization: `Basic RWFzeVBheW1lbnRBcGlVc2VyOk03dXJNJU81M1hNJA==`,
  //       "Content-Type": "application/json",
  //     },
  //   });
  // },

  SetPaid(token, invoiceID, paymentType, postID) {
    return axios({
      method: "post",
      url: `${BASE_URL}/flow/post-set-paid`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        invoiceID,
        paymentType,
        postID,
      },
    });
  },

  SetPaid(token, invoiceID, paymentType, postID) {
    return axios({
      method: "post",
      url: `${BASE_URL}/flow/post-set-paid`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        invoiceID,
        paymentType,
        postID,
      },
    });
  },

  UpdateOrderAndPostByCustomer(token, orderID, customerID, name, lastname, phone, email, deliveryTypeInfo) {
    return axios({
      method: "post",
      url: `${BASE_URL}/flow/update-order-and-post-by-customer`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        orderID,
        customerID,
        name,
        lastname,
        phone,
        email,
        deliveryTypeInfo,
      },
    });
  },

  AddInvoice(token, invoice) {
    return axios({
      method: "post",
      url: `${EP_URL}/invoices/add`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: invoice,
    });
  },
};
